<div>
  <booking-failures-table-filters [isDisabled]="isLoading"
                                  (filtered)="onFilter($event)">
  </booking-failures-table-filters>
</div>

<div>
  <booking-failures-table [bookingFailures]="bookingFailures"></booking-failures-table>
</div>
